<template>
  <div class="dialog-box">
    <el-dialog :close-on-click-modal="false" :show-close="false" :visible.sync="centerDialogVisible" width="70%" show-close center>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column align="center" prop="payer" label="付款方"></el-table-column>
        <el-table-column align="center" prop="saver" label="收款方"></el-table-column>
        <el-table-column align="center" prop="feeType" label="费用类型">
          <template slot-scope="scope">
            <span v-if="scope.row.feeType == 1">租金</span>
            <span v-if="scope.row.feeType == 2">租金（续费）</span>
            <span v-if="scope.row.feeType == 3">租金（退款）</span>
              <span v-if="scope.row.feeType == 11">油费</span>
              <span v-if="scope.row.feeType == 21">油费（续费）</span>
              <span v-if="scope.row.feeType == 31">油费（退款）</span>
            <span v-if="scope.row.feeType == 4">服务费</span>
<!--            <span v-if="scope.row.incomeType == 4">付款</span>-->
<!--            <span v-if="scope.row.incomeType == 5">退款</span>-->
<!--            <span v-if="scope.row.incomeType == 6">付款（续）</span>-->
<!--            <span v-if="scope.row.incomeType == 7">退款（续）</span>-->
<!--            <span v-if="scope.row.incomeType == 8">收款</span>-->
          </template>
        </el-table-column>
        <el-table-column align="center" prop="type" label="支付状态">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 1">未付款</span>
            <span v-if="scope.row.type == 2">未收款</span>
            <span v-if="scope.row.type == 3">已完结</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="fee" label="金额"></el-table-column>
        <el-table-column align="center" prop="payTime" label="支付时间"></el-table-column>
        <el-table-column align="center" prop="saveTime" label="收款时间"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "jsDan",
  data() {
    return {
      centerDialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    showDialog(val) {
      this.centerDialogVisible = true;
      this.tableData = val;
    },
  },
};
</script>
<style lang="less" scoped>
.dialog-box {
  font-size: 0;

  .dialog-tit {
    position: absolute;
    text-align: center;
    line-height: 0.47rem;
    width: 0.47rem;
    height: 0.47rem;
    right: -0.63rem;
    top: -0.1rem;
    background: #fff;
    border-radius: 50%;
    color: #000;
    font-size: 0.26rem;
    cursor: pointer;
  }
}
</style>
